import { render, staticRenderFns } from "./newusergroup.vue?vue&type=template&id=24fc95d9&"
import script from "./newusergroup.vue?vue&type=script&lang=js&"
export * from "./newusergroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports